###*
  * Allows to configure and save set of columns for each dataset
###

class INTENT.report.PresetManager

  @datasets: {}
  @presets: {}
  @config_popup: null

  constructor: (@controller) ->
    @code = @controller.code + '-preset'
    @attr = @controller.attr + '-preset'
    @attr_popup = @attr + '-config-popup'

    @el = @controller.el
    @datasets = @controller.datasets

    @config_popup = $("[#{@attr_popup}]")
    if !@config_popup.length
      @config_popup = $ @get_config_popup_html()
      $('body').append @config_popup

    @presets = {}
    presets_data = @el.data("#{@code}-list") or {}
    for dataset_code of presets_data
      if not @datasets[dataset_code]?
        continue
      dataset_fields = @datasets[dataset_code].fields
      preset = presets_data[dataset_code]
      fields_orig = preset.fields or []
      fields_parsed = []
      for field_code in fields_orig
        if field_code in dataset_fields
          fields_parsed.push field_code

      preset.fields = fields_parsed
      @presets[dataset_code] = preset

    @refresh_config_button()
    @init_events()

  refresh_config_button: () =>
    total_columns = @controller.get_dataset().fields.length
    showing_columns = @get_preset_fields().length or total_columns

    $("[#{@attr_popup}-open]").html('<i class="fa fa-cog"></i> ' + __('report.show_columns_count', {
      ':showing': showing_columns,
      ':total': total_columns
    })).removeClass('hidden')

  reset_to_defaults: =>
    exclude_fields = @controller.get_dataset().exclude_from_default

    @config_popup.find("[#{@attr_popup}-checkbox]").prop('checked', true).trigger('change')
    for key in exclude_fields
      @config_popup.find("[#{@attr_popup}-checkbox][name='#{key}']").prop('checked', false).trigger('change')

  get_default_fields: (dataset_code) =>
    exclude_fields = @controller.get_dataset(dataset_code).exclude_from_default
    defaults = []
    for key in @controller.get_dataset().fields
      if key not in exclude_fields
        defaults.push(key)

    return defaults

  save_config: (callback) =>
    preset_fields = []
    preset_obj = @config_popup.find('form').serializeObject()
    for field of preset_obj
      preset_fields.push field

    $.ajax
      url: '/livereports/save_preset/',
      method: 'post',
      data:
        dataset: @controller.get_dataset_code()
        preset:
          fields: preset_fields
      beforeSend: () =>
      complete: () =>
        if _.isFunction callback
          do callback
      success: (data) =>
        if data
          if data.success
            @set_preset_fields(preset_fields)
            @refresh_config_button()
            @config_popup.modal 'hide'
          else if data.error
            INTENT.utils.Notify.error data.error

  set_preset_fields: (preset_fields, dataset_code) =>
    dataset_code = dataset_code || @controller.get_dataset_code()
    preset = @presets[dataset_code] or {}
    preset.fields = preset_fields
    @presets[dataset_code] = preset
    @controller.settingsManager.update_key_selects(dataset_code)


  get_preset_fields: (dataset_code) =>
    dataset_code = dataset_code || @controller.get_dataset_code()
    dataset = @controller.get_dataset(dataset_code)
    preset = @presets[dataset_code] or {}
    fields = preset.fields or @get_default_fields(dataset_code) or []

    hash_columns = null
    hash = window.location.hash
    hash_parts = hash.replace('#', '').split('&')
    for item in hash_parts
      [key, param] = item.split('=')
      if key is 'values'
        hash_columns = param.split(',')

    if hash_columns && hash_columns.length
      fields = _.intersection hash_columns, dataset.fields
    return fields

  get_config_popup_html: () =>
    """
    <div #{@attr_popup} class="modal fade report-config-popup" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="#{__('close')}"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" #{@attr_popup}-title></h4>
          </div>
          <div class="modal-body" #{@attr_popup}-body></div>
          <div class="modal-footer">
            <button type="button" class="pull-left btn btn-default" #{@attr_popup}-select-all>
              <i class="fa fa-fw fa-check-square-o"></i> #{__('report.preset.select_all')}
            </button>
            <button type="button" class="pull-left btn btn-default" #{@attr_popup}-select-cancel>
              <i class="fa fa-fw fa-square-o"></i> #{__('report.preset.select_none')}
            </button>
            <button type="button" class="pull-left btn btn-default" #{@attr_popup}-reset-defaults>
              <i class="fa fa-fw fa-undo"></i> #{__('report.preset.reset_to_defaults')}
            </button>
            <button type="button" class="btn btn-link" data-dismiss="modal">#{__('cancel')}</button>
            <button type="button" class="btn btn-primary" #{@attr_popup}-apply>#{__('apply')}</button>
          </div>
        </div>
      </div>
    </div>
    """

  get_groups_html: (dataset_code) =>
    dataset = @controller.get_dataset(dataset_code)
    if !dataset
      return ""

    groups = dataset.groups

    fields_grouped = []
    for group_code of groups
      fields_grouped = _.union(fields_grouped, groups[group_code])

    fields_not_grouped = _.difference(dataset.fields, fields_grouped)
    if fields_not_grouped.length
      groups['#'] = fields_not_grouped

    groups_html = ""
    for group_code of groups
      group_fields = _.filter groups[group_code], (v) ->
        return v in dataset.fields

      if _.size group_fields

        group_html = @get_group_fields_html(dataset_code, group_code, group_fields)

        if _.keys(groups).length > 1
          group_html =
            """
              <div class="panel panel-default panel-small">
                <div class="panel-heading clearfix">
                  <span class="pull-left panel-title">
                    #{@controller.get_group_name(group_code)}
                  </span>
                  <div class="pull-right">
                    <a href="#"
                       title="#{__('report.config_popup.groups.select_all')}"
                       data-toggle="tooltip"
                       class="btn btn-xs btn-default"
                       #{@attr_popup}-group-select-all="#{group_code}">
                      <i class="fa fa-fw fa-check-square-o"></i>
                    </a>
                    <a href="#"
                       title="#{__('report.config_popup.groups.select_none')}"
                       data-toggle="tooltip"
                       class="btn btn-xs btn-default"
                       #{@attr_popup}-group-select-cancel="#{group_code}">
                      <i class="fa fa-fw fa-square-o"></i>
                    </a>
                  </div>
                </div>
                <div class="panel-body">
                  #{group_html}
                </div>
              </div>
            """

        groups_html += "<div #{@attr_popup}-group='#{group_code}' class='fields-group'>#{group_html}</div>"

    """
    <div class="row checkbox-table">
      <form>#{groups_html}</form>
    </div>
    """

  get_group_fields_html: (dataset_code, group_code, group_fields) =>
    dataset = @controller.get_dataset(dataset_code)
    if !dataset
      return ""

    if !_.isArray(group_fields) or !group_fields.length
      return ""

    preset_fields = @get_preset_fields(dataset_code)

    fields_html = ""
    for field_code in group_fields
      checked = !preset_fields.length or field_code in preset_fields
      fields_html +=
        """
          <div class="col-sm-6 col-md-3">
            <div class="checkbox">
              <label>
                <input type="checkbox"
                       name="#{field_code}"
                       value="1"
                       #{if checked then 'checked="checked"' else ''}
                       #{@attr_popup}-checkbox
                >
                #{@controller.get_field_name(field_code)}
              </label>
            </div>
          </div>
        """

    return fields_html

  reset_hash_fields: =>
    if @controller.settingsManager
      @controller.settingsManager.set_watch_hash no
      window.location.hash = window.location.hash.replace(/&values=.+?&/, '&')
      window.location.hash = window.location.hash.replace(/&values=.+?$/, '')
      setTimeout (=>
        @controller.settingsManager.set_watch_hash on
      ), 0

  init_events: () =>
    $("[#{@attr_popup}-open]").on 'click', (e) =>
      e.preventDefault()
      dataset_code = @controller.get_dataset_code()
      dataset_name = @controller.get_dataset(dataset_code).name
      @config_popup.find("[#{@attr_popup}-title]").text dataset_name
      @config_popup.find("[#{@attr_popup}-body]").html @get_groups_html(dataset_code)
      @config_popup.modal 'show'
      INTENT.utils.Tooltip.init()

    $("[#{@attr_popup}-apply]").on 'click', (e) =>
      e.preventDefault()
      @reset_hash_fields()
      self = $ e.currentTarget
      if self.hasClass('disabled')
        return

      self.showLoader('disabled')
      @save_config () -> self.hideLoader('disabled')

    $(document).on "#{@controller.code}:dataset_changed", (e, dataset_code) =>
      @refresh_config_button()

    $(document).on 'click', "[#{@attr_popup}-reset-defaults]", (e) =>
      e.preventDefault()
      @reset_hash_fields()
      @reset_to_defaults()

    $(document).on 'click', "[#{@attr_popup}-select-all]", (e) =>
      e.preventDefault()
      $("[#{@attr_popup}-checkbox]:not(:checked)").prop('checked', true).trigger('change')

    $(document).on 'click', "[#{@attr_popup}-select-cancel]", (e) =>
      e.preventDefault()
      $("[#{@attr_popup}-checkbox]:checked").prop('checked', false).trigger('change')
      @reset_hash_fields()

    $(document).on 'click', "[#{@attr_popup}-group-select-all]", (e) =>
      e.preventDefault()
      self = $ e.currentTarget
      group_code = self.attr("#{@attr_popup}-group-select-all")
      group =
        $("[#{@attr_popup}-group='#{group_code}']")
        .find("[#{@attr_popup}-checkbox]:not(:checked)")
        .prop('checked', true)
        .trigger('change')

    $(document).on 'click', "[#{@attr_popup}-group-select-cancel]", (e) =>
      e.preventDefault()
      self = $ e.currentTarget
      group_code = self.attr("#{@attr_popup}-group-select-cancel")
      group =
        $("[#{@attr_popup}-group='#{group_code}']")
        .find("[#{@attr_popup}-checkbox]:checked")
        .prop('checked', false)
        .trigger('change')

    $(document).on 'change', "[#{@attr_popup}-checkbox]", () =>
      checked_count = $("[#{@attr_popup}-checkbox]:checked").length
      $("[#{@attr_popup}-apply]").toggleClass('disabled', !checked_count)
